export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const CLEAR_UPDATE_STATE = "CLEAR_UPDATE_STATE";

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";

export const USER_PROFILE_REQUEST = "USER_PROFILE_REQUEST";
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_FAIL = "USER_PROFILE_FAIL";

export const PROFILE_UPDATE_REQUEST = "PROFILE_UPDATE_REQUEST";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const PROFILE_UPDATE_FAIL = "PROFILE_UPDATE_FAIL";

export const PROFILE_HELP_REQUEST = "PROFILE_HELP_REQUEST";
export const PROFILE_HELP_SUCCESS = "PROFILE_HELP_SUCCESS";
export const PROFILE_HELP_FAIL = "PROFILE_HELP_FAIL";

export const CLEAR_STATE = "CLEAR_STATE";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_USER_LOADING = "CLEAR_USER_LOADING";
export const CLEAR_PROFILE_ERRORS = "CLEAR_PROFILE_ERRORS";

export const USER_GOAL_UPDATE_REQUEST = "USER_GOAL_UPDATE_REQUEST"
export const USER_GOAL_UPDATE_SUCCESS = "USER_GOAL_UPDATE_SUCCESS";
export const USER_GOAL_UPDATE_FAIL = "USER_GOAL_UPDATE_FAIL";